










import Vue from 'vue';
import {Component, Prop} from 'vue-property-decorator';

@Component
export default class QRCode extends Vue {
  @Prop({required: true}) toggle!: boolean;

  hidden() {
    this.$emit('update:toggle', !this.toggle);
  }

}
